import { environment } from '@lla-platform/core/core-util'

export const SALARIES_SUMMARY_API_URL = {
  summary: `${environment.apiUrl}/salaries/summary`,
  export: `${environment.apiUrl}/salaries/summary/export`,
  detail: `${environment.apiUrl}/salaries/detail`
}

export const ADMIN_API_URL = {
  weeklyTargets: `${environment.apiUrl}/admin/location/weekly-targets`,
  overrideWeeklyTargets: `${environment.apiUrl}/admin/location/weekly-targets/override`,
  overrideMonthlyTargets: `${environment.apiUrl}/admin/location/monthly-targets/override`,
  protractorLocationsList: `${environment.apiUrl}/admin/location/unconfigured-protractor-list`,
  usersList: `${environment.apiUrl}/admin/filters/users`,
  userPermissions: (userId?: string) =>
    `${environment.apiUrl}/admin/permissions${userId ? '/' + userId : ''}`,
  bulkEditLocations: `${environment.apiUrl}/admin/users/bulk-edit/locations`,
  bulkEditPermissions: `${environment.apiUrl}/admin/users/bulk-edit/permissions`,
  bulkInsertPermissions: `${environment.apiUrl}/admin/users/bulk-insert/permissions`,
  adminLocationsList: `${environment.apiUrl}/admin/filters/locations`,
  exportAdminLocationsList: `${environment.apiUrl}/admin/filters/locations/export`,
  adminLocationBase: (locationId: string) => `${environment.apiUrl}/admin/location/${locationId}`,
  createLocation: `${environment.apiUrl}/admin/location/create`,
  dailyReports: (locationId: string) => `${environment.apiUrl}/admin/daily-reports/${locationId}`,
  preLlaInvoices: (locationId: string) => `${environment.apiUrl}/admin/pre-lla-invoices/${locationId}`,
  queueMessages: `${environment.apiUrl}/admin/queue-messages`,
  attentionProposals: `${environment.apiUrl}/admin/location/attention-proposals`,
  applyAttentionProposals: `${environment.apiUrl}/admin/location/attention-proposals/apply`,
  usafAccountStatus: `${environment.apiUrl}/admin/usaf-account-status`
}
